import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function setAuthHeader(token) {
    if (token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        try { localStorage.setItem('ns_session_token', token); } catch (_) { /* ignore */ }
    } else {
        delete api.defaults.headers.common['Authorization'];
        try { localStorage.removeItem('ns_session_token'); } catch (_) { /* ignore */ }
    }
}

// Restore token on load (useful when third-party cookies are blocked)
try {
    const t = localStorage.getItem('ns_session_token');
    if (t) api.defaults.headers.common['Authorization'] = `Bearer ${t}`;
} catch (_) { /* ignore */ }
